export default ({
  MODAL_OPENED            : 'MODAL_OPENED',
  MODAL_CLOSED            : 'MODAL_CLOSED',
  MODAL_SET_MANAGER       : 'MODAL_SET_MANAGER',
  MODAL_SET_BY_NAME_PROPS : 'MODAL_SET_BY_NAME_PROPS',
  MODAL_SET_PROPS : 'MODAL_SET_PROPS'
});